function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Fragment, useState } from 'react';
import Facade from '../../Facade';
import { useGrid } from '../hook';
import NoDataComponent from '../NoData';
import Accordion from 'react-bootstrap/Accordion';
import TRManageDrag from '../../FormManager/GridField/TRManageDrag';
import Icon from '../../Icon';
import { chainedDataIndexExtractor } from '../../../common/utils/chainedDataIndex';
import { SortOrder } from '../../../common/utils/data';

const Body = ({
  as: {
    NoData = NoDataComponent
  } = {}
}) => {
  const {
    query,
    columns,
    rowAttr,
    collapsible,
    collapseRender,
    draggable,
    isDraggable,
    sort,
    perPage,
    page,
    filters
  } = useGrid();
  const hasCollapsible = !!collapsible;
  const tableState = {
    perPage,
    page,
    filters,
    sort
  };
  const totalColumn = columns.length + (isDraggable ? 1 : 0) + (hasCollapsible ? 1 : 0);
  const TBODY = hasCollapsible ? Accordion : 'tbody';
  const ROW = isDraggable ? TRManageDrag : 'tr';
  const onPointerDown = isDraggable ? event => {
    if (!(event.target.matches('.grid-item-grab') || event.target.closest('.grid-item-grab'))) {
      event.stopPropagation();
    }
  } : undefined;
  const [activeAccordionKey, setActiveAccordionKey] = useState();
  const tbodyProps = hasCollapsible ? {
    as: "tbody",
    activeKey: activeAccordionKey,
    onSelect: eventKey => setActiveAccordionKey(eventKey)
  } : {};
  return /*#__PURE__*/React.createElement(TBODY, _extends({
    [`data-${draggable?.droppable || 'droppable'}-container`]: isDraggable
  }, tbodyProps), query.data.length > 0 ? (perPage < query.data.length ? query.data.slice(page * perPage - perPage, page * perPage) : query.data).map((row, index) => {
    const key = `${index}-${row?.ID || ''}`;
    const rowAttribute = rowAttr && rowAttr(row);
    const isCollapsible = collapsible && collapsible(row);
    const tds = columns.map((column, tdindex) => {
      const cellData = chainedDataIndexExtractor(column.dataIndex, row);
      const cellAttribute = column.cellAttr && column.cellAttr(row, index, tableState);
      const isShowColumn = column.showColumnWhen ? column.showColumnWhen(tableState) : true;
      const isMounted = column.mountCellWhen ? column.mountCellWhen(row, tdindex, tableState) : true;
      return isShowColumn && isMounted ? /*#__PURE__*/React.createElement("td", _extends({
        key: tdindex,
        "aria-sort": sort.orderBy === column.dataIndex ? sort.order === SortOrder.ASC ? "ascending" : "descending" : "none"
      }, cellAttribute), typeof column.render === "function" ? column.render(cellData, row, index, tableState) : !cellData && typeof cellData !== 'number' ? "-" : cellData) : null;
    });
    const draggableProps = {
      [`data-${draggable?.draggable || 'draggable'}-item`]: isDraggable
    };
    return isCollapsible ? /*#__PURE__*/React.createElement(Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement(Accordion.Toggle, _extends({
      eventKey: key,
      as: ROW,
      className: "collapsible-toggle",
      "data-id": row?.ID || ""
    }, rowAttribute, draggableProps, {
      onPointerDown: onPointerDown
    }), isDraggable && /*#__PURE__*/React.createElement("td", {
      className: "grid-item-grab"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "grip-vertical"
    })), hasCollapsible && /*#__PURE__*/React.createElement("td", {
      className: "grid-item-accordion"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: activeAccordionKey === key ? 'minus' : 'plus'
    })), tds), /*#__PURE__*/React.createElement("tr", {
      className: "collapsible"
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: totalColumn
    }, /*#__PURE__*/React.createElement(Accordion.Collapse, {
      eventKey: key
    }, /*#__PURE__*/React.createElement("div", {
      className: "collapsible-container"
    }, collapseRender && collapseRender(row, index, tableState)))))) : /*#__PURE__*/React.createElement(ROW, _extends({
      key: key,
      "data-id": row?.ID || ''
    }, rowAttribute, draggableProps, {
      onPointerDown: onPointerDown
    }), isDraggable && /*#__PURE__*/React.createElement("td", {
      className: "grid-item-grab"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "grip-vertical"
    })), hasCollapsible && /*#__PURE__*/React.createElement("td", {
      className: "grid-item-accordion"
    }), tds);
  }) : query.loading ? new Array(perPage).fill(0).map((_, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, isDraggable && /*#__PURE__*/React.createElement("td", {
    className: "grid-item-grab"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "grip-vertical"
  })), hasCollapsible && /*#__PURE__*/React.createElement("td", {
    className: "grid-item-accordion"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus"
  })), columns.map((column, index) => {
    const isShowColumn = column.showColumnWhen ? column.showColumnWhen(tableState) : true;
    return isShowColumn ? /*#__PURE__*/React.createElement("td", {
      key: index,
      "data-facade": "true"
    }, /*#__PURE__*/React.createElement(Facade, {
      loading: true,
      rows: 1,
      padding: false,
      range: column.label === "Actions" ? [100, 100] : [Math.min(totalColumn * 15, 100), Math.min(totalColumn * 20, 100)]
    })) : null;
  }))) : /*#__PURE__*/React.createElement(NoData, {
    totalColumn: totalColumn
  }));
};

export default Body;